import { createReducer, on } from '@ngrx/store'
import { serviciosExternos } from '../actions/servicios-externos.actions'
import { TokenInterface } from '@shared/interfaces/app.state.interfaces'

export const initialState: TokenInterface = { token: '', exp: '' }

export const serviciosExternosReducer = createReducer(
    initialState,
    on(serviciosExternos, ((state, { item }) => {
        return { ...state, token: item.token, exp: item.exp }
    }))
)